import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const tracker = axios.create({ baseURL: API, withCredentials: true });

// Fires a lightweight page-view beacon on every route change (role-agnostic).
export default function PageTracker() {
  const location = useLocation();
  const lastPath = useRef('');

  useEffect(() => {
    const path = location.pathname; // pathname only — never capture query strings (may hold tokens)
    if (path === lastPath.current) return;
    lastPath.current = path;
    // Skip the OAuth callback hash round-trip.
    if (location.hash && location.hash.includes('session_id=')) return;
    tracker.post('/track', {
      path,
      title: document.title || '',
      referrer: document.referrer || '',
    }).catch(() => {});
  }, [location.pathname, location.hash]);

  return null;
}
